import { createSlice } from "@reduxjs/toolkit";

export const genrationVariable = 15

const initialState = {
 genrationVariable: false
};

export const customVariables = createSlice({
  name: "customVariables",
  initialState: initialState,
  reducers: {
    updateVariables: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateVariables } = customVariables.actions;

export default customVariables.reducer;